import DateFnsAdapter from '@date-io/date-fns'
import { EmojiEventsOutlined, FlashOnOutlined, MonetizationOn, MoneyOff, SpeakerNotes } from '@mui/icons-material'
import { Typography } from '@mui/material'
import ptBR from 'date-fns/locale/pt-BR'
import { getPastDateInTimestamp } from 'utils/date'
import { getMidnight } from 'utils/dateToEpoch'
import blueLight from 'utils/colors/blueLight'

export const LAST_SEVEN_DAYS = getMidnight(new Date().setDate(new Date().getDate() - 7))

export const today = new Date()

export const yesterday = new Date(today)
yesterday.setDate(yesterday.getDate() - 1)

export const dateFns = new DateFnsAdapter({ locale: ptBR })

export const OPTIONS = [
  {
    label: 'Hoje',
    period: [dateFns.startOfDay(today), dateFns.endOfDay(today)],
  },
  {
    label: 'Últimos 7 dias',
    period: [new Date(getPastDateInTimestamp(7) * 1000), new Date(getPastDateInTimestamp(1, true) * 1000)],
  },
  {
    label: 'Esta semana',
    period: [dateFns.startOfWeek(today), dateFns.endOfDay(today)],
  },
  { label: 'Este mês', period: [dateFns.startOfMonth(today), dateFns.endOfDay(today)] },
]

export const CARD_OBJECT = {
  allChat: {
    label: {
      content: 'Todas as Conversas',
      tooltip: (
        <Typography color="inherit">
          O número de conversas por mensagens no WhatsApp entre sua empresa e os usuários. Uma conversa inclui todas as
          mensagens entregues em um período de 24 horas.
          <br />
          <br />
          Uma conversa começa quando a primeira mensagem da empresa é entregue e termina 24 horas depois. A primeira
          mensagem pode ser iniciada pela empresa <strong>(iniciada pela empresa)</strong> ou pode ser uma resposta da
          empresa até 24 horas após uma mensagem do usuário <strong>(iniciada pelo usuário).</strong>
          <br />
          <br />
          Para a finalidade desta métrica, a definição de usuário é a pessoa ou entidade com quem a empresa está
          trocando mensagens.
        </Typography>
      ),
    },
    captions: ['Iniciadas pela empresa', 'Iniciada(s) pelo usuário'],
    icon: (
      <SpeakerNotes
        fontSize="small"
        sx={{
          color: '#00AEEF',
        }}
      />
    ),
  },
  freeChat: {
    label: {
      content: 'Conversas gratuitas',
      tooltip: (
        <Typography color="inherit">
          O número de conversas por mensagens no WhatsApp entre sua empresa e os usuários que são gratuitas. Uma
          conversa inclui todas as mensagens entregues em um período de 24 horas.
          <br />
          <br />
          Uma conversa começa quando a primeira mensagem da empresa é entregue e termina 24 horas depois. A exceção são
          as conversas com ponto de entrada gratuito, que têm um período de 72 horas.
          <br />
          <br />A primeira mensagem pode ser iniciada pela empresa <strong>(iniciada pela empresa)</strong> ou pode ser
          uma resposta da empresa até 24 horas após uma mensagem do usuário <strong>(iniciada pelo usuário)</strong>.
          <br />
          <br />
          Para a finalidade desta métrica, a definição de usuário é a pessoa física ou jurídica com quem a empresa está
          trocando mensagens.
        </Typography>
      ),
    },
    captions: ['Iniciadas pela empresa', 'Iniciada(s) pelo usuário'],
    icon: (
      <MoneyOff
        fontSize="small"
        sx={{
          color: '#00AEEF',
        }}
      />
    ),
  },
  regularChat: {
    label: {
      content: 'Conversas pagas',
      tooltip: (
        <Typography color="inherit">
          O número de conversas por mensagens no WhatsApp entre sua empresa e os usuários que são cobradas. Uma conversa
          inclui todas as mensagens entregues em um período de 24 horas.
          <br />
          <br />
          Uma conversa começa quando a primeira mensagem da empresa é entregue e termina 24 horas depois. A primeira
          mensagem pode ser iniciada pela empresa <strong>(iniciada pela empresa)</strong> ou pode ser uma resposta da
          empresa até 24 horas após uma mensagem do usuário <strong>(iniciada pelo usuário).</strong>
          <br />
          <br />
          Para a finalidade desta métrica, a definição de usuário é a pessoa ou entidade com quem a empresa está
          trocando mensagens.
        </Typography>
      ),
    },
    captions: ['Iniciadas pela empresa', 'Iniciada(s) pelo usuário'],
    icon: (
      <MonetizationOn
        fontSize="small"
        sx={{
          color: '#00AEEF',
        }}
      />
    ),
  },
}

export const CARD_OBJECT_CONVERSATION = {
  allChatCategory: {
    label: {
      content: 'Todas as Conversas',
      tooltip: (
        <Typography color="inherit">
          O número de conversas por mensagens no WhatsApp entre sua empresa e os usuários. Uma conversa inclui todas as
          mensagens entregues em um período de 24 horas.
          <br />
          <br />
          Uma conversa começa quando a primeira mensagem da empresa é entregue e termina 24 horas depois. A primeira
          mensagem pode ser iniciada pela empresa <strong>(iniciada pela empresa)</strong> ou pode ser uma resposta da
          empresa até 24 horas após uma mensagem do usuário <strong>(iniciada pelo usuário).</strong>
          <br />
          <br />
          Para a finalidade desta métrica, a definição de usuário é a pessoa ou entidade com quem a empresa está
          trocando mensagens.
        </Typography>
      ),
    },
    captions: ['Marketing', 'Marketing - Lite', 'Utilidade', 'Autenticação', 'Serviço'],
    icon: (
      <SpeakerNotes
        fontSize="small"
        sx={{
          color: '#00AEEF',
        }}
      />
    ),
  },
  freeChat: {
    label: {
      content: 'Conversas gratuitas',
      tooltip: (
        <Typography color="inherit">
          O número de conversas por mensagens no WhatsApp entre sua empresa e os usuários que são gratuitas. Uma
          conversa inclui todas as mensagens entregues em um período de 24 horas.
          <br />
          <br />
          Uma conversa começa quando a primeira mensagem da empresa é entregue e termina 24 horas depois. A exceção são
          as conversas com ponto de entrada gratuito, que têm um período de 72 horas.
          <br />
          <br />A primeira mensagem pode ser iniciada pela empresa <strong>(iniciada pela empresa)</strong> ou pode ser
          uma resposta da empresa até 24 horas após uma mensagem do usuário <strong>(iniciada pelo usuário)</strong>.
          <br />
          <br />
          Para a finalidade desta métrica, a definição de usuário é a pessoa física ou jurídica com quem a empresa está
          trocando mensagens.
        </Typography>
      ),
    },
    captions: ['Nível gratuito', 'Entrada gratuito'],
    icon: (
      <MoneyOff
        fontSize="small"
        sx={{
          color: '#00AEEF',
        }}
      />
    ),
  },
  regularChatCategory: {
    label: {
      content: 'Conversas pagas',
      tooltip: (
        <Typography color="inherit">
          O número de conversas por mensagens no WhatsApp entre sua empresa e os usuários que são cobradas. Uma conversa
          inclui todas as mensagens entregues em um período de 24 horas.
          <br />
          <br />
          Uma conversa começa quando a primeira mensagem da empresa é entregue e termina 24 horas depois. A primeira
          mensagem pode ser iniciada pela empresa <strong>(iniciada pela empresa)</strong> ou pode ser uma resposta da
          empresa até 24 horas após uma mensagem do usuário <strong>(iniciada pelo usuário).</strong>
          <br />
          <br />
          Para a finalidade desta métrica, a definição de usuário é a pessoa ou entidade com quem a empresa está
          trocando mensagens.
        </Typography>
      ),
    },
    captions: ['Marketing', 'Marketing - Lite', 'Utilidade', 'Autenticação', 'Serviço'],

    icon: (
      <MonetizationOn
        fontSize="small"
        sx={{
          color: '#00AEEF',
        }}
      />
    ),
  },
}

export const TYPES_TIER = {
  ALL: 'ALL',
  FREE: 'FREE_TIER',
  REGULAR: 'REGULAR',
}

const PRICING_ICON_COLOR = blueLight[600].toUpperCase()

export const CARD_OBJECT_PRICING = {
  allChatCategory: {
    label: {
      content: 'Todas as mensagens',
      tooltip: (
        <Typography color="inherit">
          O número de mensagens que sua empresa enviou para contas no WhatsApp. Algumas contas podem não ter recebido se
          o dispositivo estava inoperante, entre outros motivos.
        </Typography>
      ),
    },
    captions: ['Marketing', 'Marketing - Lite', 'Utilidade', 'Autenticação', 'Serviço'],
    icon: (
      <SpeakerNotes
        fontSize="small"
        sx={{
          color: PRICING_ICON_COLOR,
        }}
      />
    ),
  },
  freeChat: {
    label: {
      content: 'Mensagens gratuitas',
      tooltip: (
        <Typography color="inherit">
          O número de mensagens gratuitas entregues pela sua empresa a contas do WhatsApp. As mensagens entregues são
          consideradas gratuitas quando se enquadram na janela de ponto de entrada gratuito de 72 horas ou quando são
          mensagens de serviço que se enquadram no seu limite mensal de mensagens de serviço gratuitas.
        </Typography>
      ),
    },
    captions: ['Utilidade', 'Serviço'],
    icon: (
      <MoneyOff
        fontSize="small"
        sx={{
          color: PRICING_ICON_COLOR,
        }}
      />
    ),
  },
  regularChatCategory: {
    label: {
      content: 'Mensagens pagas',
      tooltip: (
        <Typography color="inherit">
          Consideramos pagas as mensagens entregues pela sua empresa a contas no WhatsApp: marketing, utilidade,
          autenticação e, a partir de 01/10/2026, mensagens de serviço entregues após o uso do nível gratuito. Uma
          mensagem entregue significa que uma mensagem da empresa foi entregue a um usuário.
          <br />
          <br />
          Para a finalidade desta métrica, a definição de usuário é a pessoa ou entidade com quem a empresa está
          trocando mensagens.
        </Typography>
      ),
    },
    captions: ['Marketing', 'Marketing - Lite', 'Utilidade', 'Autenticação', 'Serviço'],

    icon: (
      <MonetizationOn
        fontSize="small"
        sx={{
          color: PRICING_ICON_COLOR,
        }}
      />
    ),
  },
}

// Period before 01/10/2026: the report as it was on main, without Serviço
export const CARD_OBJECT_PRICING_LEGACY = {
  allChatCategory: {
    ...CARD_OBJECT_PRICING.allChatCategory,
    captions: CARD_OBJECT_PRICING.allChatCategory.captions.slice(0, 4),
  },
  freeChat: {
    ...CARD_OBJECT_PRICING.freeChat,
    label: {
      content: 'Mensagens gratuitas',
      tooltip: (
        <Typography color="inherit">
          O número de mensagens (utilidade) entregues a usuários no WhatsApp pela sua empresa dentro da janela de
          atendimento ao cliente de 24 horas. Uma janela de atendimento ao cliente (janela de 24 horas) começa (ou é
          atualizada, caso já tenha sido iniciada) sempre que um usuário do WhatsApp envia uma mensagem a você.
          <br />
          <br />
          Para a finalidade desta métrica, a definição de usuário é a pessoa ou entidade com quem a empresa está
          trocando mensagens.
        </Typography>
      ),
    },
    captions: ['Utilidade'],
  },
  regularChatCategory: {
    ...CARD_OBJECT_PRICING.regularChatCategory,
    label: {
      content: 'Mensagens pagas',
      tooltip: (
        <Typography color="inherit">
          Consideramos pagas o número de mensagens entregues pela empresa a contas no WhatsApp. Uma mensagem entregue
          significa que uma mensagem da empresa foi entregue a um usuário. A mensagem pode ser iniciada pela empresa,
          como as de marketing, utilidade ou autenticação.
          <br />
          <br />
          Para a finalidade desta métrica, a definição de usuário é a pessoa ou entidade com quem a empresa está
          trocando mensagens.
        </Typography>
      ),
    },
    captions: CARD_OBJECT_PRICING.regularChatCategory.captions.slice(0, 4),
  },
}

export const getCardObjectPricing = (isLegacy) => (isLegacy ? CARD_OBJECT_PRICING_LEGACY : CARD_OBJECT_PRICING)

export const MODEL_CATEGORIES = [
  {
    id: 0,
    value: 'Utility',
    label: 'Utilidades',
  },
  {
    id: 1,
    value: 'Marketing',
    label: 'Marketing',
  },
  {
    id: 2,
    value: 'Authentication',
    label: 'Autenticação',
  },
]

export const MODEL_STATUS = [
  {
    id: 0,
    value: 'Approved',
    label: 'Aprovado',
  },
  {
    id: 1,
    value: 'Pending',
    label: 'Em análise',
  },
  {
    id: 2,
    value: 'InAppeal',
    label: 'Em apelação',
  },
  {
    id: 3,
    value: 'Paused',
    label: 'Pausado',
  },
  {
    id: 4,
    value: 'LimitExceeded',
    label: 'Limite excedido',
  },
  {
    id: 5,
    value: 'Rejected',
    label: 'Rejeitado',
  },
  {
    id: 6,
    value: 'Disabled',
    label: 'Desabilitado',
  },
]

export const MODEL_QUALITY = [
  {
    id: 0,
    value: 'none',
    label: 'Indisponível',
  },
  {
    id: 1,
    value: 'green',
    label: 'Alta',
  },
  {
    id: 2,
    value: 'yellow',
    label: 'Média',
  },
  {
    id: 3,
    value: 'red',
    label: 'Baixa',
  },
  {
    id: 4,
    value: 'unknown',
    label: 'Desconhecido',
  },
]

export const MODEL_VISIBILITY = [
  {
    id: 0,
    value: 'true',
    label: 'Oculto',
  },
  {
    id: 1,
    value: 'false',
    label: 'Visível',
  },
]

export const INITIAL_CHECKBOX_STATE = {
  addSecurityRecommendation: false,
  codeExpirationMinutes: false,
}

export const MAX_CONTENT = 1024
export const MAX_ELEMENT_NAME = 512
export const MAX_FOOTER = 60
export const MAX_HEADER_TEXT = 60
export const MAX_BUTTONS = 25
export const MAX_BUTTON_URL = 2000
export const MAX_CODE_LENGTH = 15
export const BUTTON_TYPES = ['Static', 'Dynamic', 'PhoneNumber', 'CopyCode']
export const MAP_BUTTON_TYPES = Object.freeze({
  Static: 'Url',
  Dynamic: 'Url',
  PhoneNumber: 'PhoneNumber',
  CopyCode: 'CopyCode',
})

export const MODEL_ROUTES = {
  MODEL_LIST: `/whatsapp-resources/modelsList`,
  SENT_MESSAGE_LIST: `/whatsapp-resources/sentMessageList`,
  CREATE_MODEL_PARTNER: `/model/partner/create`,
  CREATE_MODEL_HI: `/model/create/:businessId?/:modelId?`,
  SEND_MESSAGE: `/sendMessage/:businessId?/:modelId?`,
  FLOWS: `/whatsapp-resources/flows`,
}

// init object routes
export const CONVERSION_REPORT_ROUTES = {
  REPORT: 'report',
  MANAGEMENT_EVENTS: 'management-events',
  EVENTS_ENABLE: 'management-events/:eventId/:eventType/enable',
  EVENTS_EDIT: 'management-events/:eventId/:eventType/edit',
}

export const HSM_REPORT_ROUTES = {
  REPORT: 'report',
  MONITORING_NUMBERS: 'monitoring-numbers',
}

export const ACCOUNTS_CONNECTION_ROUTES = {
  ACCOUNTS: 'accounts',
  MANAGEMENT_WHATSAPP_ACCOUNTS: 'management-whatsapp-accounts',
}
// end Object routes

export const CONVERSION_EVENTS_KEYS = {
  conversion: 'conversion',
  event: 'event',
}

export const CONVERSION_EVENTS_OBJECT = {
  conversion: {
    title: 'Conversão',
    label: 'conversão',
    icon: (color) => (
      <EmojiEventsOutlined
        sx={{
          color,
        }}
      />
    ),
  },
  event: {
    title: 'Eventos',
    label: 'evento',
    icon: (color) => (
      <FlashOnOutlined
        sx={{
          color,
          fill: 'none',
          stroke: 'currentColor',
          strokeWidth: '1.7',
        }}
      />
    ),
  },
}

export const NUMBER_QUALITY_VALUES = ['none', 'green', 'yellow', 'red', 'unknown']

export const NUMBER_QUALITY = [
  { label: 'Indisponível', id: 0 },
  { label: 'Alta', id: 1 },
  { label: 'Média', id: 2 },
  { label: 'Baixa', id: 3 },
  { label: 'Desconhecido', id: 4 },
]

export const NUMBER_STATUS_VALUES = [
  'none',
  'pending',
  'deleted',
  'migrated',
  'banned',
  'restricted',
  'rate_limited',
  'flagged',
  'connected',
  'disconnected',
  'unknown',
  'unverified',
]

export const NUMBER_STATUS = [
  { label: 'Indisponível', id: 0 },
  { label: 'Pendente', id: 1 },
  { label: 'Deletado', id: 2 },
  { label: 'Migrado', id: 3 },
  { label: 'Banido', id: 4 },
  { label: 'Restrito [3]', id: 5 },
  { label: 'Restrito [2]', id: 6 },
  { label: 'Restrito [1]', id: 7 },
  { label: 'Conectado', id: 8 },
  { label: 'Desconectado', id: 9 },
  { label: 'Desconhecido', id: 10 },
  { label: 'Não verificado', id: 11 },
].sort((a, b) => {
  if (a.label > b.label) {
    return 1
  }

  if (a.label < b.label) {
    return -1
  }
  return 0
})

export const MESSAGE_LIMIT_VALUES = [
  'none',
  'tier_50',
  'tier_250',
  'tier_1k',
  'tier_10k',
  'tier_100k',
  'tier_unlimited',
]

export const MESSAGE_LIMIT_DESCRIPTION = {
  none: 'Indisponível',
  tier_50: 'Cinquenta a cada 24h',
  tier_250: 'Duzentos e cinquenta a cada 24h',
  tier_1k: 'Mil a cada 24h',
  tier_10k: 'Dez mil a cada 24h',
  tier_100k: 'Cem mil a cada 24h',
  tier_unlimited: 'Ilimitado',
}

export const MARKETING_MESSAGE_API_STATUS_VALUES = [`ineligible`, `eligible`, `onboarded`, `unknown`, `awaiting`]

export const MARKETING_MESSAGE_API_STATUS = [
  { label: 'Não elegível', id: 0 },
  { label: 'Elegível', id: 1 },
  { label: 'Concluído', id: 2 },
  { label: 'Desconhecido', id: 3 },
  { label: 'Aguardando', id: 4 },
]
export const EXPORT_HISTORY_STATUS_VALUES = ['awaiting', 'inProcess', 'processed', 'error']
export const EXPORT_HISTORY_STATUS = [
  { label: 'Aguardando', id: 0 },
  { label: 'Processando', id: 1 },
  { label: 'Disponível', id: 2 },
  { label: 'Erro', id: 3 },
].sort((a, b) => {
  if (a.label > b.label) {
    return 1
  }

  if (a.label < b.label) {
    return -1
  }
  return 0
})

export const CHANNEL_LIST = {
  whatsapp: {
    title: 'WhatsApp',
    avatar: (
      <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M24.0961 0.407593C10.9921 0.407593 0.312118 11.0876 0.312118 24.1916C0.312118 28.3916 1.41612 32.4716 3.48012 36.0716L0.120117 48.4076L12.7201 45.0956C16.2001 46.9916 20.1121 47.9996 24.0961 47.9996C37.2001 47.9996 47.8801 37.3196 47.8801 24.2156C47.8801 17.8556 45.4081 11.8796 40.9201 7.39159C36.4321 2.87959 30.4561 0.407593 24.0961 0.407593ZM24.1201 4.41559C29.4001 4.41559 34.3441 6.47959 38.0881 10.2236C41.8081 13.9676 43.8721 18.9356 43.8721 24.2156C43.8721 35.1116 34.9921 43.9676 24.0961 43.9676C20.5441 43.9676 17.0641 43.0316 14.0401 41.2076L13.3201 40.7996L5.83212 42.7676L7.82412 35.4716L7.34412 34.7036C5.37612 31.6076 4.32012 27.9356 4.32012 24.1916C4.34412 13.2956 13.2001 4.41559 24.1201 4.41559ZM15.6721 13.1996C15.2881 13.1996 14.6401 13.3436 14.0881 13.9436C13.5601 14.5436 12.0001 16.0076 12.0001 18.9116C12.0001 21.8396 14.1361 24.6476 14.4001 25.0556C14.7361 25.4636 18.6241 31.4636 24.6001 34.0076C26.0161 34.6556 27.1201 35.0156 27.9841 35.2796C29.4001 35.7356 30.6961 35.6636 31.7281 35.5196C32.8801 35.3516 35.2321 34.0796 35.7361 32.6876C36.2401 31.2956 36.2401 30.1196 36.0961 29.8556C35.9281 29.6156 35.5441 29.4716 34.9441 29.2076C34.3441 28.8716 31.4161 27.4316 30.8881 27.2396C30.3361 27.0476 30.0001 26.9516 29.5441 27.5276C29.1601 28.1276 28.0081 29.4716 27.6721 29.8556C27.3121 30.2636 26.9761 30.3116 26.4001 30.0236C25.7761 29.7116 23.8561 29.0876 21.6001 27.0716C19.8241 25.4876 18.6481 23.5436 18.2881 22.9436C18.0001 22.3676 18.2641 22.0076 18.5521 21.7436C18.8161 21.4796 19.2001 21.0476 19.4401 20.6876C19.7521 20.3516 19.8481 20.0876 20.0401 19.7036C20.2321 19.2956 20.1361 18.9596 19.9921 18.6716C19.8481 18.4076 18.6481 15.4316 18.1441 14.2556C17.6641 13.1036 17.1841 13.2476 16.8001 13.2236C16.4641 13.2236 16.0801 13.1996 15.6721 13.1996Z"
          fill="#05C611"
        />
      </svg>
    ),
    description: 'Conecte e gerencie os números de telefone e WABAs para uso com WhatsApp.',
    caption: 'Você precisa ter permissão de administrador no Gerenciador do WhatsApp da Meta para conectar um canal.',
    pathToPage: `/${ACCOUNTS_CONNECTION_ROUTES.MANAGEMENT_WHATSAPP_ACCOUNTS}`,
  },
  instagram: {
    title: 'Instagram',
    avatar: (
      <svg width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_665_42777)">
          <path
            d="M37.6826 48.3823L11.03 48.4076C5.16646 48.4129 0.364995 43.6208 0.358332 37.7572L0.333012 11.1046C0.327682 5.24105 5.11982 0.43958 10.9834 0.432917L37.636 0.407597C43.4996 0.402267 48.301 5.1944 48.3077 11.058L48.333 37.7106C48.3397 43.5755 43.5462 48.3769 37.6826 48.3823Z"
            fill="url(#paint0_radial_665_42777)"
          />
          <path
            d="M37.6826 48.3823L11.03 48.4076C5.16646 48.4129 0.364995 43.6208 0.358332 37.7572L0.333012 11.1046C0.327682 5.24105 5.11982 0.43958 10.9834 0.432917L37.636 0.407597C43.4995 0.402267 48.301 5.1944 48.3077 11.058L48.333 37.7106C48.3397 43.5755 43.5462 48.3769 37.6826 48.3823Z"
            fill="url(#paint1_radial_665_42777)"
          />
          <path
            d="M24.3329 32.1615C20.0584 32.1615 16.5791 28.6833 16.5791 24.4077C16.5791 20.132 20.0584 16.6538 24.3329 16.6538C28.6075 16.6538 32.0868 20.132 32.0868 24.4077C32.0868 28.6833 28.6075 32.1615 24.3329 32.1615ZM24.3329 18.8692C21.279 18.8692 18.7945 21.3537 18.7945 24.4077C18.7945 27.4616 21.279 29.9461 24.3329 29.9461C27.3869 29.9461 29.8714 27.4616 29.8714 24.4077C29.8714 21.3537 27.3869 18.8692 24.3329 18.8692Z"
            fill="white"
          />
          <path
            d="M32.6401 17.7614C33.5577 17.7614 34.3016 17.0175 34.3016 16.0999C34.3016 15.1823 33.5577 14.4384 32.6401 14.4384C31.7224 14.4384 30.9785 15.1823 30.9785 16.0999C30.9785 17.0175 31.7224 17.7614 32.6401 17.7614Z"
            fill="white"
          />
          <path
            d="M30.9788 38.8076H17.6865C13.4119 38.8076 9.93262 35.3294 9.93262 31.0537V17.7614C9.93262 13.4857 13.4119 10.0076 17.6865 10.0076H30.9788C35.2534 10.0076 38.7326 13.4857 38.7326 17.7614V31.0537C38.7326 35.3294 35.2534 38.8076 30.9788 38.8076ZM17.6865 12.223C14.6326 12.223 12.148 14.7075 12.148 17.7614V31.0537C12.148 34.1076 14.6326 36.5922 17.6865 36.5922H30.9788C34.0327 36.5922 36.5172 34.1076 36.5172 31.0537V17.7614C36.5172 14.7075 34.0327 12.223 30.9788 12.223H17.6865Z"
            fill="white"
          />
        </g>
        <defs>
          <radialGradient
            id="paint0_radial_665_42777"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(18.1769 48.4422) scale(59.8337 59.8337)"
          >
            <stop stopColor="#FFDD55" />
            <stop offset="0.328" stopColor="#FF543F" />
            <stop offset="0.348" stopColor="#FC5245" />
            <stop offset="0.504" stopColor="#E64771" />
            <stop offset="0.643" stopColor="#D53E91" />
            <stop offset="0.761" stopColor="#CC39A4" />
            <stop offset="0.841" stopColor="#C837AB" />
          </radialGradient>
          <radialGradient
            id="paint1_radial_665_42777"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(8.05693 -0.191683) scale(39.7297 26.4719)"
          >
            <stop stopColor="#4168C9" />
            <stop offset="0.999" stopColor="#4168C9" stopOpacity="0" />
          </radialGradient>
          <clipPath id="clip0_665_42777">
            <rect x="0.333008" y="0.407593" width="48" height="48" rx="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    description: 'Conecte suas contas do Instagram para atender seus clientes via Bot e Hi Chat.',
    caption: 'Você precisa ter permissão de administrador na Meta para conectar contas Instagram.',
    pathToPage: '/accountsSelfConnection?channel=instagram',
  },
  messenger: {
    title: 'Messenger',
    avatar: (
      <svg width="49" height="50" viewBox="0 0 49 50" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M48.667 24.2366C48.667 37.1609 37.927 47.6371 24.667 47.6371C22.6858 47.6371 20.767 47.4043 18.9262 46.9603C18.3682 46.8259 17.785 46.8775 17.2714 47.1343L12.019 49.7611C10.663 50.4392 9.06699 49.4527 9.06699 47.9359V43.1058C9.06699 42.4158 8.75859 41.7726 8.24979 41.307C3.57699 37.0349 0.666992 30.9688 0.666992 24.2366C0.666992 11.3124 11.407 0.836182 24.667 0.836182C37.927 0.836182 48.667 11.3124 48.667 24.2366Z"
          fill="url(#paint0_radial_665_42807)"
        />
        <path
          opacity="0.05"
          d="M38.283 16.8363C37.775 16.8363 37.2825 17.0041 36.8588 17.3219L30.1007 22.3024C29.9429 22.4206 29.7684 22.4797 29.5844 22.4797C29.4064 22.4797 29.2391 22.4242 29.0978 22.319L24.3836 18.786C23.4246 18.0758 22.2947 17.7012 21.1114 17.7012C19.2409 17.7012 17.5211 18.6359 16.5111 20.2015L15.0738 22.436L10.1839 30.3469C9.71867 31.0724 9.68306 31.9681 10.0997 32.7266C10.5246 33.4994 11.3269 33.9792 12.1933 33.9792C12.7013 33.9792 13.1938 33.8114 13.6175 33.4935L20.3755 28.513C20.5334 28.3949 20.7079 28.3358 20.8918 28.3358C21.0699 28.3358 21.2372 28.3913 21.3785 28.4965L26.0927 32.0295C27.0529 32.7408 28.1816 33.1142 29.3649 33.1142C31.2354 33.1142 32.9551 32.1796 33.9652 30.6139L35.4025 28.3795L40.2924 20.4686C40.7576 19.7431 40.7932 18.8474 40.3766 18.0888C39.9517 17.316 39.1494 16.8363 38.283 16.8363Z"
          fill="black"
        />
        <path
          opacity="0.07"
          d="M37.7326 17.9791C37.3534 17.9791 36.9836 18.1059 36.6638 18.3463L29.8911 23.3421C29.6343 23.5351 29.3347 23.6358 29.0208 23.6358C28.7129 23.6358 28.4216 23.5387 28.1768 23.3563L23.4535 19.8138C22.5987 19.1801 21.5894 18.8461 20.5325 18.8461C18.8622 18.8461 17.3274 19.6811 16.4251 21.0811L14.9866 23.3207L10.0946 31.242C9.74148 31.7927 9.71414 32.4655 10.0256 33.0316C10.3418 33.6072 10.9612 33.9791 11.6008 33.9791C11.9801 33.9791 12.3498 33.8524 12.6696 33.612L19.4424 28.6162C19.6992 28.4231 19.9988 28.3225 20.3126 28.3225C20.6205 28.3225 20.9118 28.4196 21.1567 28.602L25.8799 32.1445C26.7347 32.7781 27.744 33.1121 28.8009 33.1121C30.4712 33.1121 32.006 32.2771 32.9083 30.8772L34.3468 28.6375L39.2389 20.7163C39.5919 20.1655 39.6193 19.4928 39.3078 18.9266C38.9916 18.351 38.3734 17.9791 37.7326 17.9791Z"
          fill="black"
        />
        <path
          d="M37.613 18.2279L30.8263 23.2405C30.1 23.7869 29.1118 23.7869 28.3974 23.2524L23.6658 19.6997C21.6655 18.2149 18.8318 18.7256 17.4863 20.8162L16.0457 23.0612L11.1521 30.9958C10.4377 32.1123 11.807 33.3833 12.8666 32.5874L19.6533 27.5749C20.3796 27.0285 21.3678 27.0285 22.0822 27.563L26.8138 31.1157C28.8141 32.6005 31.6479 32.0898 32.9933 29.9992L34.434 27.7542L39.3275 19.8196C40.0419 18.7031 38.6727 17.4321 37.613 18.2279Z"
          fill="white"
        />
        <defs>
          <radialGradient
            id="paint0_radial_665_42807"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(9.17139 47.6107) scale(57.1344 57.1355)"
          >
            <stop stopColor="#1292FF" />
            <stop offset="0.079" stopColor="#2982FF" />
            <stop offset="0.23" stopColor="#4E69FF" />
            <stop offset="0.351" stopColor="#6559FF" />
            <stop offset="0.428" stopColor="#6D53FF" />
            <stop offset="0.754" stopColor="#DF47AA" />
            <stop offset="0.946" stopColor="#FF6257" />
          </radialGradient>
        </defs>
      </svg>
    ),
    description: 'Conecte suas contas do Messenger para atender seus clientes via Bot e Hi Chat.',
    caption: 'Você precisa ter permissão de administrador na Meta para conectar contas Messenger.',
    pathToPage: '/accountsSelfConnection?channel=messenger',
  },
  metaAds: {
    title: 'Meta Ads',
    avatar: (
      <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g>
          <circle cx="24" cy="24.4076" r="24" fill="#0181FB" />
          <path
            d="M39.8125 28.0926L38.3048 29.2359L36.8012 28.1888C36.8012 28.0788 36.8013 27.962 36.7944 27.8451C36.7944 27.7351 36.7944 27.6182 36.7875 27.5013C36.6912 24.7926 36.0037 21.8913 34.6287 19.767C33.57 18.1376 32.2156 17.3607 30.7031 17.3607C29.115 17.3607 27.8225 18.3095 26.3925 20.372C26.3512 20.4338 26.3031 20.4957 26.2619 20.5645C26.2344 20.5988 26.2138 20.6332 26.1863 20.6745C26.1175 20.7776 26.0487 20.8807 25.98 20.9907C25.3612 21.9532 24.715 23.0738 24.0138 24.3113C23.9519 24.4282 23.8831 24.5451 23.8212 24.662C23.8006 24.6895 23.78 24.7238 23.7662 24.7513L23.6219 25.0057L22.7694 26.5113C20.7687 30.052 20.26 30.8632 19.2631 32.1901C17.51 34.5207 16.0113 35.4076 14.0381 35.4076C11.7006 35.4076 10.2156 34.397 9.30125 32.8707C8.55187 31.6332 8.1875 30.0038 8.1875 28.1476L11.6044 28.2645C11.6044 29.4745 11.8656 30.3957 12.2162 30.9595C12.67 31.6882 13.3369 31.9701 14.0312 31.9701C14.9181 31.9701 15.7431 31.7845 17.3106 29.612C18.5688 27.8726 20.0537 25.4388 21.0506 23.9057L21.9925 22.4688L22.1919 22.1526L22.3981 21.8432L22.7419 21.3138C23.2644 20.5163 23.8281 19.6707 24.4331 18.8595C24.5019 18.7632 24.5706 18.667 24.6462 18.5707C24.715 18.4745 24.7906 18.3782 24.8594 18.2888C25.4781 17.4982 26.1313 16.7626 26.8325 16.1576C28.1044 15.0507 29.4725 14.4388 30.8544 14.4388C33.1713 14.4388 35.3781 15.7795 37.0694 18.2957C38.795 20.867 39.6956 24.0707 39.7987 27.4051C39.8056 27.5151 39.8056 27.632 39.8056 27.7488C39.8125 27.8657 39.8125 27.9757 39.8125 28.0926Z"
            fill="white"
          />
          <path
            d="M10.8809 18.5336C12.4463 16.1239 14.7068 14.4388 17.2987 14.4388C18.8002 14.4388 20.292 14.8823 21.8506 16.1528C23.5549 17.5415 25.372 19.8282 27.6387 23.597L28.4513 24.9493C30.4134 28.2122 31.5292 29.8904 32.183 30.6824C33.0232 31.6992 33.5477 31.9701 34.3122 31.9701C36.251 31.9701 36.7989 30.2238 36.7989 28.1882L39.8122 28.094C39.8122 30.2218 39.3922 31.7852 38.6772 33.0199C37.9869 34.2141 36.6408 35.4076 34.3762 35.4076C32.9682 35.4076 31.721 35.1023 30.3419 33.8037C29.2818 32.8068 28.0422 31.0358 27.0887 29.4442L24.252 24.7149C22.8289 22.3417 21.5234 20.5713 20.7678 19.7704C19.9552 18.9083 18.9514 17.877 17.2842 17.877C15.9347 17.877 14.748 18.8134 13.789 20.2592L10.8809 18.5336Z"
            fill="white"
          />
          <path
            d="M17.2969 17.8763C15.9501 17.8763 14.7648 18.8127 13.8078 20.2585C12.4541 22.3018 11.625 25.3447 11.625 28.2672C11.625 29.4724 11.6229 30.3792 11.9688 30.9388L9.32875 32.8728C8.58213 31.6312 8.1875 30.0451 8.1875 28.1888C8.1875 24.8132 9.11906 21.2513 10.8811 18.5336C12.4445 16.1239 14.7236 14.4388 17.3106 14.4388L17.2969 17.8763Z"
            fill="white"
          />
          <path
            opacity="0.05"
            d="M22.3978 21.8432L22.1916 22.1526L21.9922 22.4688C22.4803 23.1769 23.0372 24.0294 23.6216 25.0057L23.7659 24.7513C23.7797 24.7238 23.8003 24.6894 23.8209 24.6619C23.8828 24.5451 23.9516 24.4282 24.0134 24.3113C23.4428 23.3763 22.8928 22.5444 22.3978 21.8432ZM24.6459 18.5707C24.5703 18.6669 24.5016 18.7632 24.4328 18.8594C24.9347 19.4851 25.4434 20.1932 25.9797 20.9907C26.0484 20.8807 26.1172 20.7776 26.1859 20.6744C26.2134 20.6332 26.2341 20.5988 26.2616 20.5644C26.3028 20.4957 26.3509 20.4338 26.3922 20.3719C25.8697 19.6019 25.3609 18.9076 24.8591 18.2888C24.7903 18.3782 24.7147 18.4744 24.6459 18.5707Z"
            fill="black"
          />
          <path
            opacity="0.07"
            d="M22.3977 21.8432L22.1914 22.1526C22.6795 22.8538 23.2295 23.6926 23.8208 24.6619C23.8827 24.5451 23.9514 24.4282 24.0133 24.3113C23.4427 23.3763 22.8927 22.5444 22.3977 21.8432ZM24.4327 18.8594C24.9345 19.4851 25.4433 20.1932 25.9795 20.9907C26.0483 20.8807 26.117 20.7776 26.1858 20.6744C25.6564 19.8907 25.1408 19.1894 24.6458 18.5707C24.5702 18.6669 24.5014 18.7632 24.4327 18.8594Z"
            fill="black"
          />
        </g>
      </svg>
    ),
    description: 'Conecte suas contas Meta Ads e analise seus anúncios criados no ecossistema Meta.',
    caption:
      'Você precisa ter permissão de administrador no Gerenciador de Comércio da Meta para conectar uma conta Meta Ads.',
    pathToPage: '/accountsSelfConnection?channel=metaAds',
  },
  catalog: {
    title: 'Catálogo WhatsApp',
    avatar: (
      <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24" cy="24.4076" r="24" fill="url(#paint0_linear_665_42866)" />
        <path
          d="M27.55 25.4076C28.3 25.4076 28.96 24.9976 29.3 24.3776L32.88 17.8876C32.9643 17.736 33.0075 17.5651 33.0054 17.3916C33.0034 17.2182 32.956 17.0484 32.8681 16.8989C32.7803 16.7493 32.6549 16.6254 32.5043 16.5392C32.3538 16.453 32.1834 16.4077 32.01 16.4076H17.21L16.27 14.4076H13V16.4076H15L18.6 23.9976L17.25 26.4376C16.52 27.7776 17.48 29.4076 19 29.4076H31V27.4076H19L20.1 25.4076H27.55ZM18.16 18.4076H30.31L27.55 23.4076H20.53L18.16 18.4076ZM19 30.4076C17.9 30.4076 17.01 31.3076 17.01 32.4076C17.01 33.5076 17.9 34.4076 19 34.4076C20.1 34.4076 21 33.5076 21 32.4076C21 31.3076 20.1 30.4076 19 30.4076ZM29 30.4076C27.9 30.4076 27.01 31.3076 27.01 32.4076C27.01 33.5076 27.9 34.4076 29 34.4076C30.1 34.4076 31 33.5076 31 32.4076C31 31.3076 30.1 30.4076 29 30.4076Z"
          fill="white"
        />
        <defs>
          <linearGradient
            id="paint0_linear_665_42866"
            x1="0"
            y1="0.407593"
            x2="0"
            y2="48.4076"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#00C912" />
            <stop offset="1" stopColor="#31A400" />
          </linearGradient>
        </defs>
      </svg>
    ),
    description: 'Integre e sincronize seus catálogos de produtos da Meta para uso no WhatsApp.',
    caption:
      'Você precisa ter permissão de administrador no Gerenciador de Comércio da Meta para conectar catálogos de produtos.',
    pathToPage: '/accountsSelfConnection?channel=catalog',
  },
}
